import { Component } from '@angular/core';
import { BaseModal } from 'shared/abstract/base-modal';
import { ListItem } from 'shared/interfaces/list-item';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-multi-input-control-modal',
    templateUrl: './multi-input-control-modal.component.html',
    styleUrls: ['./multi-input-control-modal.component.scss'],
    imports: [TranslateModule],
})
export class MultiInputControlModalComponent extends BaseModal {
    allowChanges: boolean = true;
    data: any;

    constructor(public translate: TranslateService) {
        super();
    }

    deselectOption(option: ListItem) {
        this.data.selectedOptions.splice(
            this.data.selectedOptions.findIndex((item: ListItem) => item === option),
            1,
        );
    }

    closeModal(updateOptions: boolean = false) {
        this.closeModalInstance(updateOptions ? this.data.selectedOptions : undefined);
    }
}
